(function () {
    'use strict';

    function init() {
        const linkLists = document.querySelectorAll('.js-link-list');
        if (!linkLists) return;

        linkLists.forEach((list) => {
            const showMore = list.querySelector('.js-link-list-show-more');

            showMore.addEventListener('click', () => {
                list.classList.add('is-expanded');
                showMore.blur();
                showMore.setAttribute('aria-hidden', true);
                showMore.setAttribute('aria-expanded', true);
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();